/**
 * Created by Ning Jiang on 2/7/2018.
 */

require("@nolimitcity/slot-game/lib/gsap/src/umd/CustomBounce.js");
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {IWinRatioConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {Timeline, TimelineLite, TweenLite} from "gsap";
import {DeadwoodGameConfig} from "../../DeadwoodGameConfig";
import {DeadwoodSoundConfig} from "../../DeadwoodSoundConfig";
import {BigWinParticles} from "./BigWinParticles";

export class DeadwoodBigWinView extends BaseView {

    private _gunShotTiming:number[][] = [
        [0.1, 0.1333],
        [0, 0.4667, 0.7667],
        [0, 0.2667, 0.5667, 0.7667],
        [0, 0.5667]
    ];

    private _layer:ScalableLayer;
    private _dimmer:PIXI.Graphics;
    private _goldPile:PIXI.Sprite;
    private _goldPan:PIXI.Sprite;
    private _pileAddSprite:PIXI.Sprite;
    private _pileAddSpine:PIXI.spine.Spine;
    private _particles:BigWinParticles;
    private _shootSprite:PIXI.Sprite;
    private _shootSpines:PIXI.spine.Spine[];
    private _shootAddSpines:PIXI.spine.Spine[];
    private _textSprite:PIXI.Sprite;
    private _textSpines:PIXI.spine.Spine[];
    private _frontCoinsContainer:PIXI.Container;
    private _frontCoinsSprites:PIXI.Sprite[];
    private _pigsContainer:PIXI.Container;
    private _pigsBg:PIXI.Sprite;
    private _pigsSprite:PIXI.Sprite;
    private _pigsSpine:PIXI.spine.Spine;
    private _brokenGlass:PIXI.Sprite;

    private _bounceTween:TweenLite;
    private _isShowing:boolean = false;
    private _currentLevel:number = -1;

    constructor() {
        super();

        CustomBounce.create("shotBounce", {strength : 0.4, squash : 0, endAtStart : true, squashID : "bigwin"});
        this._layer = StageManager.getLayer(DeadwoodGameConfig.instance.LAYERS.BIG_WIN.name);
    }

    protected initAnimations():void {
        this._dimmer = new PIXI.Graphics();
        this._dimmer.alpha = 0;
        this._layer.addChild(this._dimmer);

        this._goldPile = new PIXI.Sprite(GameResources.getTextures("bigWinGoldPile")[0]);
        this._goldPile.anchor.set(0.56, 1);
        this._goldPile.alpha = 0;
        this._layer.addChild(this._goldPile);

        const bottomSandFall = new PIXI.Sprite(GameResources.getTextures("bigWinSandFallBottom")[0]);
        bottomSandFall.blendMode = PIXI.BLEND_MODES.ADD;
        bottomSandFall.anchor.set(0.5, 1);
        bottomSandFall.position.set(-60, -50);
        this._goldPile.addChild(bottomSandFall);

        this._goldPan = new PIXI.Sprite(GameResources.getTextures("bigWinGoldPan")[0]);
        this._goldPan.anchor.set(0.45, 0);
        this._goldPan.alpha = 0;
        this._layer.addChild(this._goldPan);

        const topSandFall = new PIXI.Sprite(GameResources.getTextures("bigWinSandFallTop")[0]);
        topSandFall.blendMode = PIXI.BLEND_MODES.ADD;
        topSandFall.anchor.set(0.5, 0);
        topSandFall.position.set(-40, 0);
        this._goldPan.addChild(topSandFall);

        this._pileAddSprite = new PIXI.Sprite();
        this._pileAddSprite.anchor.set(0.5, 1);
        this._pileAddSprite.alpha = 0;
        this._layer.addChild(this._pileAddSprite);

        this._pileAddSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("bigWin_pileAdd"));
        this._pileAddSpine.autoUpdate = true;
        this._pileAddSprite.addChild(this._pileAddSpine);

        this._particles = new BigWinParticles();
        this._layer.addChild(this._particles);

        this._pigsContainer = new PIXI.Container();
        this._layer.addChild(this._pigsContainer);

        this._frontCoinsContainer = new PIXI.Container();
        this._frontCoinsContainer.alpha = 0;
        this._frontCoinsContainer.scale.set(1.03);
        this._layer.addChild(this._frontCoinsContainer);

        this._shootSprite = new PIXI.Sprite();
        this._shootSprite.anchor.set(0.5);
        this._shootSprite.alpha = 0;
        this._layer.addChild(this._shootSprite);

        this._textSprite = new PIXI.Sprite();
        this._textSprite.anchor.set(0.5);
        this._textSprite.alpha = 0;
        this._layer.addChild(this._textSprite);

        this._frontCoinsSprites = [];
        this._shootSpines = [];
        this._shootAddSpines = [];
        this._textSpines = [];

        for(let i:number = 0; i < 4; i++) {
            if(i < 3) {
                const frontCoins:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(`bigWinFrontCoins${2 - i}`)[0]);
                frontCoins.anchor.set(0.5, 1);
                frontCoins.alpha = 0;
                this._frontCoinsContainer.addChild(frontCoins);
                this._frontCoinsSprites.unshift(frontCoins);
            }

            const shootSpine:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset(`bigWin_shoot${i}`));
            shootSpine.autoUpdate = true;
            shootSpine.alpha = 0;
            this._shootSprite.addChild(shootSpine);
            this._shootSpines.push(shootSpine);

            const shootAddSpine:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset(`bigWin_shootAdd${i}`));
            shootAddSpine.autoUpdate = true;
            shootAddSpine.alpha = 0;
            this._shootSprite.addChild(shootAddSpine);
            this._shootAddSpines.push(shootAddSpine);

            const textSpine:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset(`bigWin_text${i}`));
            textSpine.autoUpdate = true;
            textSpine.alpha = 0;
            this._textSprite.addChild(textSpine);
            this._textSpines.push(textSpine);
        }

        this._brokenGlass = new PIXI.Sprite(GameResources.getTextures("bigWinBrokenGlass")[0]);
        this._brokenGlass.anchor.set(0.5);
        this._brokenGlass.alpha = 0;
        this._shootSprite.addChild(this._brokenGlass);
    }

    protected onResize(resizeData:IResizeData):void {
        if(!this._isShowing) {
            this._isResizeDirty = true;
            return;
        }

        const screenWidth:number = Math.ceil(resizeData.width / this._layer.scale.x);
        const screenHeight:number = Math.ceil(resizeData.height / this._layer.scale.y);
        const leftOffset:number = Math.floor(-this._layer.x / this._layer.scale.x);
        const topOffset:number = Math.floor(-this._layer.y / this._layer.scale.y);

        this._dimmer.clear();
        this._dimmer.beginFill(0x000000, 0.8);
        this._dimmer.drawRect(leftOffset - 20, topOffset - 20, screenWidth + 40, screenHeight + 40);

        // centered in the window.
        const centerX:number = screenWidth / 2 + leftOffset;
        const centerY:number = screenHeight / 2 + topOffset;
        const topY:number = topOffset - 5;
        const bottomY:number = topOffset + screenHeight + 5;
        this._goldPile.position.set(centerX, bottomY);
        this._goldPan.position.set(centerX, topY);
        this._pileAddSprite.position.set(centerX, bottomY);
        this._particles.position.set(centerX, topY - 30);
        this._shootSprite.position.set(centerX, centerY);
        this._textSprite.position.set(centerX, centerY);
        this._frontCoinsContainer.position.set(centerX, bottomY);
        this._pigsContainer.position.set(centerX, centerY);
        this.resetBounceTween();

        this._isResizeDirty = false;
    }

    private resetBounceTween():void {
        if(this._bounceTween && this._bounceTween.isActive()) {
            this._bounceTween.progress(1);
            if(StageManager.legacyScaling) {
                StageManager.stage.position.set(NolimitApplication.screenBounds.left, NolimitApplication.screenBounds.top);
            }
        }
    }

    public getBigWinLevelAnimation(level:number, winRatioConfig:IWinRatioConfig):Timeline {
        this._isShowing = true;
        if(this._isResizeDirty) {
            this.onResize(this._resizeData);
        }
        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            () => {
                this._particles.play(level);
                this._shootSpines[level].state.clearTrack(0);
                this._shootSpines[level].skeleton.setToSetupPose();
                new SpineTween(this._shootSpines[level], 0, "animation");
                this._shootAddSpines[level].state.clearTrack(0);
                this._shootAddSpines[level].skeleton.setToSetupPose();
                new SpineTween(this._shootAddSpines[level], 0, "animation");
                this.updateBigWinLevelAnimation(level, false);
            },
            this.getShakeAnimation(level),
            this.playGunSounds(level),
            TweenLite.to(this._shootSprite, 0.1, {alpha : 1}),
            TweenLite.to(this._shootSpines[level], 0.1, {alpha : 1}),
            TweenLite.to(this._shootAddSpines[level], 0.1, {alpha : 1}),
            TweenLite.to(this._frontCoinsContainer, 0.3, {alpha : 1, delay : 0.5}),
            TweenLite.to(this._frontCoinsSprites[Math.min(2, level)], 1, {alpha : 1}),
            TweenLite.to(this._textSprite.scale, winRatioConfig.duration, {x : 1})
        ], 0);

        if(level < 3) {
            timeline.add([
                () => {
                    this._pileAddSpine.state.clearTrack(0);
                    this._pileAddSpine.skeleton.setToSetupPose();
                    new SpineTween(this._pileAddSpine, 0, winRatioConfig.text!);
                },
                TweenLite.to(this._pileAddSprite, 0.1, {alpha : 1, delay : 0.4}),
                TweenLite.to(this._goldPan, 0.15, {alpha : 1, delay : 0.3}),
                TweenLite.to(this._goldPile, 0.1, {alpha : 1, delay : 0.4})
            ], 0);
        } else {
            timeline.add([
                // TweenLite.to(this._pileAddSprite, 0.15, {alpha : 0}),
                TweenLite.to(this._goldPan, 0.1, {alpha : 0}),
                TweenLite.to(this._goldPile, 0.1, {alpha : 0}),
                () => this.playPigsAnimation()
            ], 0);
            if(this._pigsSprite) {
                timeline.add(TweenLite.to(this._pigsSprite, 0.5, {
                    alpha : 0,
                    onComplete : () => {
                        this._pigsSpine.state.setEmptyAnimation(0, 0);
                    }
                }), "-=0.5");
            }
        }

        return timeline;
    }

    private updateBigWinLevelAnimation(level:number, isEnding:boolean):void {
        this._currentLevel = level;
        this._textSpines[level].state.clearTrack(0);
        this._textSpines[level].skeleton.setToSetupPose();
        this._textSpines[level].state.timeScale = isEnding ? 3 : 1;
        new SpineTween(this._textSpines[level], 0, "animation");
        TweenLite.to(this._textSpines[level], 0.2, {alpha : 1});
        TweenLite.to(this._textSprite, 0.2, {alpha : 1});

        for(let i:number = 0; i < level; i++) {
            TweenLite.to(this._textSpines[i], 0.3, {alpha : 0});
        }
    }

    private getShakeAnimation(level:number):TimelineLite {
        const shakeTimeline:TimelineLite = new TimelineLite();
        shakeTimeline.add(() => this.playBgShake());
        shakeTimeline.add(TweenLite.fromTo(this._dimmer, 0.03, {alpha : 1}, {alpha : 0.32}));
        shakeTimeline.add(TweenLite.to(this._dimmer, 0.2, {alpha : 1}));
        if(level > 0) {
            shakeTimeline.add(() => this.playBgShake(), 0.67);
            shakeTimeline.add(TweenLite.fromTo(this._dimmer, 0.03, {alpha : 1}, {alpha : 0.32}));
            shakeTimeline.add(TweenLite.to(this._dimmer, 0.2, {alpha : 1}));
        }
        if(level > 2) {
            shakeTimeline.add(() => this.playBgShake(), 1.33);
            shakeTimeline.add(TweenLite.fromTo(this._dimmer, 0.03, {alpha : 1}, {alpha : 0.32}));
            shakeTimeline.add(TweenLite.to(this._dimmer, 0.2, {alpha : 1}));
        }

        return shakeTimeline;
    }

    private playGunSounds(level:number):TimelineLite {
        const timeline:TimelineLite = new TimelineLite();
        this._gunShotTiming[level].forEach((time:number) => {
            timeline.add(() => DeadwoodSoundConfig.playGunSound(), time);
        });
        return timeline;
    }

    private playPigsAnimation():void {
        if(!this._pigsSprite) {
            this._pigsSprite = new PIXI.Sprite();
            this._pigsSprite.anchor.set(0.5);
            this._pigsSprite.alpha = 0;
            this._pigsContainer.addChild(this._pigsSprite);

            this._pigsBg = new PIXI.Sprite(GameResources.getTextures("bigWinPigBg")[0]);
            this._pigsBg.anchor.set(0.48);
            this._pigsBg.blendMode = PIXI.BLEND_MODES.ADD;
            this._pigsSprite.addChild(this._pigsBg);

            this._pigsSpine = new PIXI.spine.Spine(GameResources.getSpineAsset(`bigWin_pigs`));
            this._pigsSpine.autoUpdate = true;
            this._pigsSprite.addChild(this._pigsSpine);
        }

        this._pigsSpine.state.clearTrack(0);
        this._pigsSpine.skeleton.setToSetupPose();
        new SpineTween(this._pigsSpine, 0, "animation", -1);
        TweenLite.to(this._pigsSprite, 0.3, {alpha : 1});
        const glassTimeline:TimelineLite = new TimelineLite();
        glassTimeline.add(TweenLite.to(this._brokenGlass, 0.1, {alpha : 1}), 0.2);
        glassTimeline.add(() => {
            this._shootSpines.forEach((shootSpine:PIXI.spine.Spine) => {
                shootSpine.alpha = 0;
            });
            this._shootAddSpines.forEach((shootAddSpine:PIXI.spine.Spine) => {
                shootAddSpine.alpha = 0;
            });
        });
    }

    private playBgShake():void {
        this.resetBounceTween();
        this._bounceTween = TweenLite.to(StageManager.stage, 0.06, {
            x : `+=${(Math.random() * 5 + 5) * (Math.random() > 0.5 ? 1 : -1)}`,
            y : `+=${(Math.random() * 5 + 5) * (Math.random() > 0.5 ? 1 : -1)}`,
            ease : "shotBounce"
        });
    }

    public playEndingAnimation(endLevel:number, isAborted:boolean):void {
        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            () => {
                if(isAborted && this._currentLevel != endLevel) {
                    this.updateBigWinLevelAnimation(endLevel, true);
                }
                this._particles.stop();
            },
            TweenLite.to(this._dimmer, 0.2, {alpha : 0}),
            TweenLite.to(this._goldPan, 0.3, {alpha : 0}),
            TweenLite.to(this._goldPile, 0.3, {alpha : 0}),
            TweenLite.to(this._pileAddSprite, 0.35, {
                alpha : 0, onComplete : () => {
                    this._pileAddSpine.state.setEmptyAnimation(0, 0);
                }
            }),
            TweenLite.to(this._shootSprite, 0.35, {
                alpha : 0, onComplete : () => {
                    this._shootSpines.forEach((shootSpine:PIXI.spine.Spine) => {
                        shootSpine.state.setEmptyAnimation(0, 0);
                        shootSpine.alpha = 0;
                    });
                    this._shootAddSpines.forEach((shootAddSpine:PIXI.spine.Spine) => {
                        shootAddSpine.state.setEmptyAnimation(0, 0);
                        shootAddSpine.alpha = 0;
                    });
                    this._brokenGlass.alpha = 0;
                }
            }),
            TweenLite.to(this._frontCoinsContainer, 0.35, {
                alpha : 0, onComplete : () => {
                    this._frontCoinsSprites.forEach((frontCoins:PIXI.Sprite) => {
                        frontCoins.alpha = 0;
                    });
                }
            })
        ]);
        timeline.add(TweenLite.fromTo(this._textSprite, 0.3, {alpha : 1}, {
            alpha : 0, delay : 0.5,
            onComplete : () => {
                this._textSpines.forEach((textSpine:PIXI.spine.Spine) => {
                    textSpine.state.setEmptyAnimation(0, 0);
                    textSpine.alpha = 0;
                });
            }
        }), 0.2);
        if(this._pigsSprite) {
            timeline.add(TweenLite.to(this._pigsSprite, 0.2, {
                alpha : 0,
                onComplete : () => {
                    this._pigsSpine.state.setEmptyAnimation(0, 0);
                }
            }), 0.2);
        }
        timeline.add(() => {
            this._isShowing = false;
            this._currentLevel = -1;
        });

        timeline.play();
    }
}